import { render, staticRenderFns } from "./ProjectsNavMenuItem.vue?vue&type=template&id=0e4e8375&scoped=true&"
import script from "./ProjectsNavMenuItem.vue?vue&type=script&lang=js&"
export * from "./ProjectsNavMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsNavMenuItem.vue?vue&type=style&index=0&id=0e4e8375&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4e8375",
  null
  
)

export default component.exports